<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pt-10 pb-10">
        <div class="table-responsive">
          <table class="excel-table-2007">
            <thead>
              <tr>
                <th class="text-center established-width-200">{{ $t('total_request') }}</th>
                <th class="text-center established-width-200">{{ $t('total_invoices') }}</th>
                <th class="text-center established-width-200">{{ $t('total_checks') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ getNumberFormat(totalRequest) }}</td>
                <td class="text-center">{{ invoiceTotal }}</td>
                <td class="text-center">{{ total_global_checks }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-left" colspan="2">{{ $t('total_to_be_billed') }}: {{ getNumberFormat(getTotalInvoiced()) }}</td>
                <td class="text-left">{{ $t('total_text_payable') }}: {{ getNumberFormat(totalChecks) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <form @submit.prevent="createInvoice" @keydown="createInvoiceForm.onKeydown($event)">
        <alert-success :form="createInvoiceForm" :message="$t('info_updated')"></alert-success>

        <v-weirdo-table
          :columns="columnsBill"
          :mutable="mutable"
          :rows="rowsBill"
          :footers="footerPagesInvoice"
          :inspeccion="inspeccion"
          :separateHouse="0"
          :typeTable="'facturas'"
          :forceAppearance="determinesInspectionAction(['forceInspectionTable'])"
        ></v-weirdo-table>

        <v-button
          :disabled="!inspectionWithVerificationFiles"
          :loading="createInvoiceForm.busy"
        >{{ $t('save') }}</v-button>
      </form>

      <div v-if="invoices && invoices.length > 0" class="table-responsive">
        <table class="excel-table-2007 fixed-width-table table-hover">
          <thead class="thead-light-blue">
            <tr>
              <th class="text-center established-width-100">{{ $t('bill_number') }}</th>
              <th class="text-center established-width-100">{{ $t('file') }}</th>
              <th class="text-center established-width-100">{{ $t('actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bill, index) in invoices" :key="`invoices-tr-${index}`">
              <td class="text-center established-width-100">
                <template v-if="bill.files.length > 0">{{ bill.numero_factura }}</template>
              </td>
              <td class="text-center established-width-100">
                <template v-if="bill.files.length > 0">
                  <div
                    v-for="(file, billIndex) in bill.files"
                    :key="`invoices-td-div-${billIndex}`"
                  >
                    <template v-if="determinesInspectionAction(['export'])">
                      <a
                        :href="`/api/files/export_file/${file.id}?token=${authToken}`"
                        :title="`${file.nombre_original}`"
                        target="_blank"
                      >
                        <icon name="file-pdf" size="fa-1x"></icon>
                        {{ file.nombre_original }}
                      </a>
                    </template>
                    <template v-else>
                      {{ file.nombre_original }}
                    </template>
                  </div>
                </template>
              </td>
              <td class="text-center established-width-100">
                <template v-if="bill.files.length > 0 && determinesInspectionAction(['deleteRequestFile'])">
                  <div
                    v-for="(file, billIndex) in bill.files"
                    :key="`invoices-td-div-${billIndex}`"
                  >
                    <button
                      type="button"
                      class="btn btn-link"
                      v-on:click="deleteBillingFile(file)"
                    >
                      <icon name="trash" size="fa-1x"></icon>
                      {{ $t('delete_file') }}
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

import {
  formattedValueRetracement,
} from '../plugins/helper'
import {
  createForm,
  newAssignment,
  creationOfColumns,
} from '../plugins/helperService'
import {
  ignoreNonEditableItems,
  inspectBillAndPayments,
  getTotalInvoiceAndCheck,
} from '../pages/all_contracts/contractService'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

let newTime = null

export default {
  name: 'invoice-component',
  extends: IncludeHelperComponent,
  props: {
    billType: {
      type: String,
      required: true,
    },
    idRelationship: {
      type: Number,
      required: true,
    },
    records: {
      type: Array,
      default: () => {
        return []
      },
    },
    totalRequest: {
      type: Number,
      default: () => {
        return 0
      },
    },
    inspeccion: {
      type: Boolean,
      default: false,
    },
    inspectionStartDate: {
      type: String,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      rowsBill: [],
      invoices: [],
      mutable: false,
      totalChecks: 0,
      createInvoiceForm: new Form({
        id: 0,
        invoices: null,
        id_relationship: null,
      }),
      typePaymentsInvoice: [],
    }
  },
  computed: {
    ...mapGetters({
      'authToken': 'authToken',
      'typePayments': 'typePayments',
      'total_global_checks': 'total_global_checks',
    }),
    columnsBill() {
      const columnsDefault = [
        'Tipo de pago',
        'Número de factura',
        'Monto factura',
        'Fecha',
        'Archivo',
        'Comentario',
      ]

      return creationOfColumns(columnsDefault)
    },
    invoiceTotal() {
      const invoiceTotal = getTotalInvoiceAndCheck(this.rowsBill, 'monto_factura')
      this.$store.dispatch('getTotalGlobalInvoices', invoiceTotal)

      return invoiceTotal
    },
    inspectionWithVerificationFiles() {
      const file = this.getTheFirstOccurrenceByKey(this.rowsBill, 'file', 'type')
      if (this.checkVariable(file) && file.editable === true && file.id !== 0) {
        return true
      }

      return this.inspeccion
    },
    footerPagesInvoice: function () {
      return this.footerTableInvoices(this.columnsBill.length)
    },
  },
  watch: {
    invoiceTotal: function () {
      this.getTotalCheck()
    },
    'total_global_checks': function () {
      this.getTotalCheck()
    },
    records: function (records) {
      this.setDestroyed()
      this.setDestroyedCreateInvoiceForm()
      this.initializeAttributes()

      this.invoices = this.initialFormatObjectsInvoicesAndChecks(records)
      this.getRows(this.invoices, this.noReactive(this.typePaymentsInvoice))
    },
  },
  beforeMount: function () {
    this.setDestroyed()
    this.setDestroyedCreateInvoiceForm()
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$store.commit('GET_JIMP_START')
      this.initializeInvoicesAndChecks()
      this.initializeAttributes()
    })
  },
  methods: {
    async initializeAttributes() {
      await this.getTypePayments()
      this.getTotalCheck()
      this.setRows()
    },
    initializeInvoicesAndChecks() {
      this.invoices = this.initialFormatObjectsInvoicesAndChecks(this.records)
    },
    setRows() {
      this.typePaymentsInvoice = this.noReactive(this.typePayments)
      this.getRows(this.invoices, this.typePaymentsInvoice)
    },
    getRows(invoices, typePayments) {
      const nombres = [
        'tipo_pago_id',
        'numero_factura',
        'monto_factura',
        'fecha',
        'file',
        'comentarios',
      ]
      const typeDate = ['fecha']
      const defaultRows = newAssignment({
        template: 'facturas',
        defaultName: nombres,
        prefix: '',
        values: invoices.length > 0 ? invoices : {},
        defaultValues: {
          tipo_pago_id: typePayments,
        },
        keysForList: ['tipo_pago_id', 'file'],
        typeDate,
        idDefault: 0,
      })
      const rows = inspectBillAndPayments(defaultRows, invoices)
      if (rows && rows.length > 0) {
        this.rowsBill = this.noReactive(rows)
      } else {
        this.rowsBill = this.noReactive(defaultRows)
      }
    },
    async createInvoice() {
      try {
        this.createInvoiceForm.busy = true
        this.createInvoiceForm.id_relationship = this.idRelationship
        this.createInvoiceForm = this.handleTheLoadingOfInvoiceFiles(this.createInvoiceForm, this.rowsBill)

        const createInvoiceForm = createForm(this.createInvoiceForm)
        createInvoiceForm['invoices'] = JSON.stringify(ignoreNonEditableItems(this.rowsBill))

        const { data } = await this.postMethodShipping(createInvoiceForm, `/api/invoices/${this.billType}`)

        this.createInvoiceForm.busy = false
        this.$store.dispatch(
          'setUpdateStatus',
          {
            tabla_referencia: this.billType,
            response: data,
            ...createInvoiceForm,
          },
        )
      } catch (error) {
        console.error(error)
        this.createInvoiceForm.busy = false
      }
    },
    async deleteBillingFile(model) {
      const promise = this.actionDeleteFile('/api/invoices/file', model.id)
      this.actionDeleteThen(promise)
    },
    getTotalCheck() {
      const _this = this
      if (newTime !== null) {
        clearInterval(newTime)
      }
      const promise = new Promise (resolve => {
        newTime = setInterval(
          (totalGlobalCheck) => {
            if (totalGlobalCheck) {
              resolve(totalGlobalCheck)
            }
          },
          500,
          _this.total_global_checks,
        )
      })
      promise.then(response => {
        const totalGlobalCheck = formattedValueRetracement(response)
        _this.totalChecks = _this.totalRequest - totalGlobalCheck
        clearInterval(newTime)
      })
    },
    getTotalInvoiced() {
      const totalCheck = formattedValueRetracement(this.total_global_checks)
      const totalInvoiced = formattedValueRetracement(this.invoiceTotal)

      return (totalInvoiced - totalCheck)
    },
    setDestroyedCreateInvoiceForm() {
      this.createInvoiceForm = new Form({
        id: 0,
        invoices: null,
        id_relationship: null,
      })
    },
    setDestroyed() {
      this.rowsBill = []
      this.invoices = []
      this.mutable = false
    },
  },
  destroyed: function () {
    this.$store.commit('GET_BANK_PAYMENT_TYPES_START')
    this.setDestroyed()
    this.setDestroyedCreateInvoiceForm()
  },
}
</script>
